import { Tags } from "@risalabs_frontend_org/oasis-ui-kit";

interface SingleCredentialCardProps {
  id: string;
  title: string;
  description: string;
  isActive: boolean;
  showWarning?: boolean;
  width?: string;
  onClick?: (id: string) => void;
  isCredentialSelected?: boolean;
}

const SingleCredentialCard = ({
  id,
  title,
  description,
  isActive,
  showWarning = false,
  width,
  onClick,
  isCredentialSelected = false,
}: SingleCredentialCardProps) => {
  const handleClick = () => {
    onClick?.(id);
  };

  return (
    <div
      onClick={handleClick}
      aria-selected={isCredentialSelected}
      className={`overflow-hidden rounded-md border border-l-4 bg-white transition-all duration-200 ease-in-out ${
        isActive ? "border-l-green-600" : "border-l-red-600"
      } ${
        isCredentialSelected
          ? "border-primaryGray-4 shadow-md ring-1 ring-primaryGray-4/10"
          : "border-primaryGray-14 hover:border-primaryGray-12 hover:shadow-sm"
      } ${onClick ? "cursor-pointer" : ""} ${width ?? "w-full"}`}
    >
      <div className="flex items-center justify-between gap-2 p-3">
        <div className="min-w-0 flex-1">
          <div className="text-xs font-normal text-primaryGray-4" title={title}>
            {title}
          </div>
          <div className="truncate text-sm font-semibold" title={description}>
            {description}
          </div>
        </div>
        {showWarning && (
          <div className="shrink-0">
            <Tags label="Duplicate" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleCredentialCard;
